module.exports = __webpack_public_path__ + "img/sSearch.004756f0.svg";